<p class="mb-4">Se déconnecter</p>
<ng-casto-btn (click)="signout()" class="blue" label="Fermer"></ng-casto-btn>